// import { loadStripe } from '@stripe/stripe-js';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PaymentV1 from './payment_v1.jsx';
import PaymentV2 from './payment_v2.jsx';

// const stripePromise = loadStripe('pk_live_51RqGwMRhCrrvDMQS4XG6WGXUXddfaIlpkinEF5ipFIDb1R4FmCClTXE9etiKwKpQeQikJVGknFk0uEdLuLA5mJwA00XCXMhoyb');

function PaymentTest() {
    // Stan do przełączania widoków ('v1' lub 'v2')
    const [activeVersion, setActiveVersion] = useState('v1');

    return (
        <div className="min-h-screen bg-gray-50 p-8">
            <div className="max-w-4xl mx-auto">
                {/* Nagłówek i Przełącznik */}
                <div className="mb-8 text-center">
                    <h1 className="text-3xl font-bold text-gray-900 mb-6">
                        Panel Testowy Płatności
                    </h1>

                    {/* Zakładki (Tabs) */}
                    <div className="inline-flex bg-white rounded-lg shadow-sm p-1 border border-gray-200">
                        <button
                            onClick={() => setActiveVersion('v1')}
                            className={`px-6 py-2 rounded-md text-sm font-medium transition-all ${
                                activeVersion === 'v1'
                                    ? 'bg-blue-600 text-white shadow-md'
                                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                            }`}
                        >
                            Wersja 1 (Form Submit)
                        </button>
                        <button
                            onClick={() => setActiveVersion('v2')}
                            className={`px-6 py-2 rounded-md text-sm font-medium transition-all ${
                                activeVersion === 'v2'
                                    ? 'bg-purple-600 text-white shadow-md'
                                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                            }`}
                        >
                            Wersja 2 (Button Click)
                        </button>
                    </div>
                </div>

                {/* Opis aktualnie testowanej wersji */}
                <div className="mb-6 text-center text-sm text-gray-500">
                    {activeVersion === 'v1'
                        ? 'Testujesz: payment_v1.jsx (logika oparta na <form onSubmit>)'
                        : 'Testujesz: payment_v2.jsx (logika oparta na <button onClick>)'
                    }
                </div>

                {/* Renderowanie wybranego komponentu */}
                <div className="border-t border-gray-200 pt-6">
                    {activeVersion === 'v1' && <PaymentV1 />}
                    {activeVersion === 'v2' && <PaymentV2 />}
                </div>
            </div>
        </div>
    );
}

export default PaymentTest;